import { render, staticRenderFns } from "./AdminPunchTagForm.vue?vue&type=template&id=61ed8119"
import script from "./AdminPunchTagForm.vue?vue&type=script&lang=ts"
export * from "./AdminPunchTagForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports